import { render, staticRenderFns } from "./MediaQuick.vue?vue&type=template&id=b2b69c10&scoped=true&"
import script from "./MediaQuick.vue?vue&type=script&lang=js&"
export * from "./MediaQuick.vue?vue&type=script&lang=js&"
import style0 from "./MediaQuick.vue?vue&type=style&index=0&id=b2b69c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b69c10",
  null
  
)

export default component.exports